var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGizlilik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 407.18 475.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#e95066;}.cls-4{fill:#e2002e;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-4);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-2);}.cls-9{clip-path:url(#clippath-7);}.cls-10{clip-path:url(#clippath-8);}.cls-11{clip-path:url(#clippath-6);}.cls-12{clip-path:url(#clippath-5);}.cls-13{clip-path:url(#clippath-9);}.cls-14{clip-path:url(#clippath-10);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 407.18,
    height: 475.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m161.94,18.47v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m173.67,18.47v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m185.4,18.47v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.62,18.92c-.89-1-1.56-2.13-2.04-3.38s-.71-2.55-.71-3.9.24-2.63.71-3.88c.47-1.25,1.15-2.38,2.04-3.38h1.1c-.4.66-.77,1.39-1.1,2.19-.33.8-.59,1.64-.78,2.5-.19.86-.29,1.72-.29,2.57s.09,1.7.29,2.57c.19.87.45,1.71.77,2.52.32.8.69,1.54,1.1,2.19h-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212,4.38c.89,1,1.56,2.13,2.04,3.38.47,1.25.71,2.55.71,3.9s-.24,2.61-.71,3.87c-.47,1.26-1.15,2.39-2.04,3.39h-1.1c.41-.67.78-1.4,1.1-2.2s.58-1.63.77-2.5c.19-.87.29-1.72.29-2.56s-.09-1.71-.28-2.58-.44-1.71-.77-2.51c-.33-.81-.7-1.54-1.11-2.19h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m220.59,18.47v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.32,18.47v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.05,18.47v-1.31h8.62v1.31h-8.62Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.29,39.17v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.13,36.92v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m128.89,33.14v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m142.41,29.91l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m154.14,29.91l-.47-2.29v-2.54h1.69v2.54l-.46,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m176.83,39.64v-.26c.36-.39.62-.79.79-1.21.17-.41.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.29,1.65-.19.53-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m187.54,33.14v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.06,29.91l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.33,26.77l-1.79-2.9.02-.05h1.78l1.36,2.95h-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.73,33.14v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m235.42,36.92v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m260.28,23.89l-2.02-2.28v-.05h1.9l1.71,2.33h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m272.01,23.89l-2.02-2.28v-.05h1.9l1.71,2.33h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m281.38,33.14v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m294.07,36.92v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m302.7,39.17v-1.31h8.62v1.31h-8.62Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m71.26,60.34v-.26c.36-.39.62-.79.79-1.21.17-.41.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.29,1.65-.19.53-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.97,53.84v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.49,50.61l-.47-2.29v-2.54h1.69v2.54l-.46,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.37,60.34v-.26c.36-.39.62-.79.79-1.21s.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.28,1.65s-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m165.87,50.61l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.52,47.47l-1.79-2.9.02-.05h1.78l1.36,2.95h-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m258.88,57.61v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m318.9,47.47l-1.79-2.9.02-.05h1.78l1.36,2.95h-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m328.3,53.84v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m340.99,57.61v-2.29h2.42v2.29h-2.42Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m47.8,81.04v-.26c.36-.39.62-.79.79-1.21.17-.41.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.29,1.65-.19.53-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m60.3,71.31l-.47-2.29v-2.54h1.69v2.54l-.46,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m129.91,81.04v-.26c.36-.39.62-.79.79-1.21s.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.28,1.65s-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m142.41,71.31l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.98,68.17l-1.79-2.9.02-.05h1.78l1.36,2.95h-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m282.34,78.31v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m354.09,68.17l-1.79-2.9.02-.05h1.78l1.36,2.95h-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m364.45,78.31v-2.29h2.42v2.29h-2.42Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m32.29,101.97l8.3-14.78h1.57l-8.28,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m114.4,101.97l8.3-14.78h1.57l-8.28,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m298.63,101.97l-8.28-14.78h1.57l8.3,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m380.74,101.97l-8.28-14.78h1.57l8.3,14.78h-1.59Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.56,122.67l8.3-14.78h1.57l-8.28,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m32.91,121.98v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.67,122.67l8.3-14.78h1.57l-8.28,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.36,122.67l-8.28-14.78h1.57l8.3,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m373.08,121.98v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m392.47,122.67l-8.28-14.78h1.57l8.3,14.78h-1.59Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m49.14,127.39l-2.02-2.28v-.05h1.9l1.71,2.33h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m60.87,127.39l-2.02-2.28v-.05h1.9l1.71,2.33h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.24,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m82.94,140.41v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m90.94,143.36l8.3-14.78h1.57l-8.28,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.29,142.67v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.13,140.41v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m129.86,140.41v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m140.62,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m152.35,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m164.08,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m177.6,133.41l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m189.33,133.41l-.47-2.29v-2.54h1.69v2.54l-.46,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.06,133.41l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,143.86v-15.87h1.42v15.87h-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.09,127.39l-2.02-2.28v-.05h1.9l1.71,2.33h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m236.82,127.39l-2.02-2.28v-.05h1.9l1.71,2.33h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m246.19,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m257.92,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m269.65,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m282.34,140.41v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m294.07,140.41v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m302.7,142.67v-1.31h8.62v1.31h-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m322.09,143.36l-8.28-14.78h1.57l8.3,14.78h-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m329.32,143.14v-.26c.36-.39.62-.79.79-1.21.17-.41.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.29,1.65-.19.54-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m340.03,136.64v-1.79h4.36v1.79h-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m353.55,133.41l-.47-2.29v-2.54h1.69v2.54l-.46,2.29h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m365.28,133.41l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,164.56v-15.87h1.42v15.87h-1.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,185.27v-15.87h1.42v15.87h-1.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,205.97v-15.87h1.42v15.87h-1.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,226.67v-15.87h1.42v15.87h-1.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,247.37v-15.87h1.42v15.87h-1.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,268.06v-15.87h1.42v15.87h-1.42Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,288.76v-15.87h1.42v15.87h-1.42Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m176.83,308.74v-.26c.36-.39.62-.79.79-1.21.17-.41.25-.83.25-1.26h-.97v-2.59h2.19v2.23c0,.56-.09,1.11-.29,1.65-.19.54-.47,1.01-.84,1.44h-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.46,309.46v-15.87h1.42v15.87h-1.42Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m178.14,316.57l-1.79-2.9.02-.05h1.78l1.36,2.95h-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m188.5,326.71v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m200.24,326.71v-2.29h2.42v2.29h-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.79,319.71l-.47-2.29v-2.54h1.69v2.54l-.47,2.29h-.76Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m150.69,463.01c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-21.03,10.99h-7.42v1.13h7.42v-1.13Zm-10.65,1.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m141.79,445.21c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-6.62,4.15l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-98.61-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-10.65,1.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m241.97,431.56l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-19.62-5.61h-3.75v1.54h3.75v-1.54Zm-9.48-3.93l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-72.18,2.7l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-8.9,0h-3.75v1.54h3.75v-1.54Zm-75.04-5.39c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-13.88,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m350.33,414.99h-3.75v1.54h3.75v-1.54Zm-9.75,2.82h-2.08v1.97h2.08v-1.97Zm-9.61-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-9.48-3.93l-1.17-2.54h-1.53l-.02.05,1.54,2.49h1.17Zm-56.66-1.45c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-8.9,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91s.61-2.19.61-3.33-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.59-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-35.6,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15s.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-57.32-12.51c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-33.31,4.15l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19-1.56h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-20.2-9.54l-1.17-2.54h-1.53v.05s1.53,2.49,1.53,2.49h1.17Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m337.59,391.81c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-57.32-12.51c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-23.7,8.2h-2.08v1.97h2.08v-1.97Zm-34.68,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15s.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-75.12-12.51c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-67.28,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15s.59-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.55-11.05l-1.17-2.54h-1.53v.05s1.53,2.49,1.53,2.49h1.17Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m346.49,374.01c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-6.5,9.54h-7.42v1.13h7.42v-1.13Zm-20.2-9.54l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-38.86-1.45c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2-.38,1.46-.66,2.15c-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.5c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-10.18-2.33v-3.13h3.11v-1.32h-3.11v-3.13h-1.36v3.13h-3.11v1.32h3.11v3.13h1.36Zm-8.54-1.97h-2.08v1.97h2.08v-1.97Zm-36.31-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-10.46-1.23l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19-1.56h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-11.57-2.79h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-7.98,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-44.5,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-8.9,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m355.39,356.21c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-40.58,12.5c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-27.62-4.3h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-26.12,3.93h-3.75v1.54h3.75v-1.54Zm-8.9,0h-3.75v1.54h3.75v-1.54Zm-9.74,2.82h-2.08v1.97h2.08v-1.97Zm-56.4-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-32.6,8.2h-2.08v1.97h2.08v-1.97Zm-61.38,4.3c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.55-11.05l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.59-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-7.06-5.18h-7.6v1.32h7.6v-1.32Zm0-3.16h-7.6v1.32h7.6v-1.32Zm-11.66,4.04h-2.08v1.97h2.08v-1.97Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m346.49,338.41c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.28-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-41.5,8.2h-2.08v1.97h2.08v-1.97Zm-34.68,4.3c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.82-9.91h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-97.9,0h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-9.88,2.7l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-69.57,8.35c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-7.15-1.51h-7.42v1.13h7.42v-1.13Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m340.59,328.81h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-12.16-1.45c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21.39-1.46.67-2.15c.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.82-9.91h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-133.5,0h-2.08v1.97h2.08v-1.97Zm-11.9-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-49.48,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m307.66,313.8h-7.42v1.13h7.42v-1.13Zm-180.67-2.79h-2.08v1.97h2.08v-1.97Zm-11.9-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 104.44,
    y: 296,
    width: 7.42,
    height: 1.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGizlilik);
export default __webpack_public_path__ + "static/media/gizlilik.ca868388cc0ff558b59027ff8d1533be.svg";
export { ForwardRef as ReactComponent };